// Set CSS variable for min column width on page load
document.addEventListener('DOMContentLoaded', function () {
    var grids = document.querySelectorAll('.flexible-grid-layout[data-min-column-width]');

    grids.forEach(function (grid) {
        var minWidth = grid.getAttribute('data-min-column-width');
        var backgroundColor = grid.getAttribute('data-background-color');
        if (minWidth) {
            grid.style.setProperty('--min-column-width', minWidth + 'px');
        }
        if (backgroundColor) {
            grid.style.setProperty('background-color', backgroundColor);
        }
    });
});
